<template lang="pug">
div.stage-container
  component(
    v-for="(item, index) in story"
    :key="item.key"
    :is="getComponentName(item.type)"
    v-bind="handleItem(item)"
  ).rel
    template(v-if="item.children")
      TimersStoryRenderer(
        v-for="(child, index) in item.children"
        :key="index"
        :story="child"
      )
</template>

<script>
import _ from 'lodash'

import PageTitle from "./PageTitle.vue";
import PageSubtitle from "./PageSubtitle.vue";
import PageGap from "./PageGap.vue";
import PageSectionTitle from "./PageSectionTitle.vue";
import PageBulletList from "./PageBulletList.vue";
import PageTimers from "./PageTimers.vue";
import PageImage from "./PageImage.vue";

const componentNames = {
  title: PageTitle,
  subtitle: PageSubtitle,
  gap: PageGap,
  sectionTitle: PageSectionTitle,
  bulletList: PageBulletList,
  timers: PageTimers,
  image: PageImage,
  story: 'StoryRenderer'
}

export default {
  name: 'StoryRenderer',
  props: {
    story: { type: Array, default: () => [] },
  },
  methods: {
    getComponentName(type) {
      return _.get(componentNames, type) || type || 'div'
    },
    handleItem(item) {
      return _.omit(item, ['children'])
    },
  },
}
</script>

<style lang="scss" scoped></style>
